// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as WorkRouteImport } from './routes/work'
import { Route as AdminSplatRouteImport } from './routes/admin.$'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const WorkRoute = WorkRouteImport.update({
            id: '/work',path: '/work',getParentRoute: () => rootRouteImport
          })
const AdminSplatRoute = AdminSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => AdminRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })





const AdminRouteChildren = {
  AdminSplatRoute: AdminSplatRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AdminRoute: AdminRouteWithChildren,ContactRoute: ContactRoute,FaqRoute: FaqRoute,ServicesRoute: ServicesRoute,WorkRoute: WorkRoute,BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)